import { KeyboardEvent, MouseEvent } from 'react'

// Container props for an input whose filled state swaps the text input for a
// display + clear X. The container becomes the field's single tab stop (the X
// is not tabbable — see ClearButton), Backspace/Enter clears, and clicking the
// display doesn't focus the container (only keyboard should; the X stays
// clickable). While not filled it is focusable only programmatically.
export const filledFieldFocusProps = ({
  filled,
  disabled,
  onClear,
}: {
  filled: boolean
  disabled?: boolean
  onClear: () => void
}) => ({
  tabIndex: disabled ? undefined : filled ? 0 : -1,
  onKeyDown: (e: KeyboardEvent) => {
    if (filled && (e.key === 'Backspace' || e.key === 'Enter')) {
      e.preventDefault()
      onClear()
    }
  },
  onMouseDown: (e: MouseEvent) => {
    if (filled && !(e.target as HTMLElement).closest('button')) {
      e.preventDefault()
    }
  },
})
